
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  BusinessUnitResponse,
  ClientRefsInCompanyResponse,
  CountryResponse,
  SearchCompanyRequest,
  SearchCompanyResponse,
  SearchFreelancerAccountRequest,
  SearchFreelancerAccountResponse,
  SearchManagerRequest,
  SearchManagerResponse,
} from '../models';
import {
    BusinessUnitResponseFromJSON,
    BusinessUnitResponseToJSON,
    ClientRefsInCompanyResponseFromJSON,
    ClientRefsInCompanyResponseToJSON,
    CountryResponseFromJSON,
    CountryResponseToJSON,
    SearchCompanyRequestFromJSON,
    SearchCompanyRequestToJSON,
    SearchCompanyResponseFromJSON,
    SearchCompanyResponseToJSON,
    SearchFreelancerAccountRequestFromJSON,
    SearchFreelancerAccountRequestToJSON,
    SearchFreelancerAccountResponseFromJSON,
    SearchFreelancerAccountResponseToJSON,
    SearchManagerRequestFromJSON,
    SearchManagerRequestToJSON,
    SearchManagerResponseFromJSON,
    SearchManagerResponseToJSON,
} from '../models';

export interface GetClientRefFromCompanyRequest {
    clientCompanyId: string;
}

export interface SearchCompaniesRequest {
    searchCompanyRequest: SearchCompanyRequest;
}

export interface SearchFreelancerAccountOperationRequest {
    searchFreelancerAccountRequest: SearchFreelancerAccountRequest;
}

export interface SearchManagerOperationRequest {
    searchManagerRequest: SearchManagerRequest;
}

/**
 * 
 */
export class RegistriesApi extends runtime.BaseAPI {

    /**
     * Retrieve all business units
          */
    async getAllBusinessUnitsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<BusinessUnitResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<BusinessUnitResponse>>({
            path: `/business-referral/api/registries/business-units`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(BusinessUnitResponseFromJSON);
        return response;
    }

    /**
     * Retrieve all business units
          */
    async getAllBusinessUnits(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<BusinessUnitResponse>> {
        const response = await this.getAllBusinessUnitsRaw(initOverrides);
        return response._data;
    }

    /**
     * Retrieve all countries
          */
    async getAllCountriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CountryResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<CountryResponse>>({
            path: `/business-referral/api/registries/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CountryResponseFromJSON);
        return response;
    }

    /**
     * Retrieve all countries
          */
    async getAllCountries(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CountryResponse>> {
        const response = await this.getAllCountriesRaw(initOverrides);
        return response._data;
    }

    /**
     * Retrieve all client reference within a given client company
          */
    async getClientRefFromCompanyRaw(requestParameters: GetClientRefFromCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientRefsInCompanyResponse>> {
        if (requestParameters['clientCompanyId'] == null) {
            throw new runtime.RequiredError(
                'clientCompanyId',
                'Required parameter "clientCompanyId" was null or undefined when calling getClientRefFromCompany().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['clientCompanyId'] != null) {
            queryParameters['clientCompanyId'] = requestParameters['clientCompanyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientRefsInCompanyResponse>({
            path: `/business-referral/api/registries/client-refs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientRefsInCompanyResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve all client reference within a given client company
          */
    async getClientRefFromCompany(requestParameters: GetClientRefFromCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientRefsInCompanyResponse> {
        const response = await this.getClientRefFromCompanyRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve countries that are not blacklisted
          */
    async getSupportedCountriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CountryResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<CountryResponse>>({
            path: `/business-referral/api/registries/supported-countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CountryResponseFromJSON);
        return response;
    }

    /**
     * Retrieve countries that are not blacklisted
          */
    async getSupportedCountries(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CountryResponse>> {
        const response = await this.getSupportedCountriesRaw(initOverrides);
        return response._data;
    }

    /**
     * Post a search request to get companies autocomplete list
          */
    async searchCompaniesRaw(requestParameters: SearchCompaniesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SearchCompanyResponse>> {
        if (requestParameters['searchCompanyRequest'] == null) {
            throw new runtime.RequiredError(
                'searchCompanyRequest',
                'Required parameter "searchCompanyRequest" was null or undefined when calling searchCompanies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SearchCompanyResponse>({
            path: `/business-referral/api/registries/search-companies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchCompanyRequestToJSON(requestParameters['searchCompanyRequest']),
        }, initOverrides);

        if (response._data) { response._data=SearchCompanyResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Post a search request to get companies autocomplete list
          */
    async searchCompanies(requestParameters: SearchCompaniesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SearchCompanyResponse> {
        const response = await this.searchCompaniesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Post a search request to get freelancers list from it
          */
    async searchFreelancerAccountRaw(requestParameters: SearchFreelancerAccountOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SearchFreelancerAccountResponse>> {
        if (requestParameters['searchFreelancerAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'searchFreelancerAccountRequest',
                'Required parameter "searchFreelancerAccountRequest" was null or undefined when calling searchFreelancerAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SearchFreelancerAccountResponse>({
            path: `/business-referral/api/registries/search-freelancers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchFreelancerAccountRequestToJSON(requestParameters['searchFreelancerAccountRequest']),
        }, initOverrides);

        if (response._data) { response._data=SearchFreelancerAccountResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Post a search request to get freelancers list from it
          */
    async searchFreelancerAccount(requestParameters: SearchFreelancerAccountOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SearchFreelancerAccountResponse> {
        const response = await this.searchFreelancerAccountRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Post a search request to get managers list from it
          */
    async searchManagerRaw(requestParameters: SearchManagerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SearchManagerResponse>> {
        if (requestParameters['searchManagerRequest'] == null) {
            throw new runtime.RequiredError(
                'searchManagerRequest',
                'Required parameter "searchManagerRequest" was null or undefined when calling searchManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SearchManagerResponse>({
            path: `/business-referral/api/registries/search-managers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchManagerRequestToJSON(requestParameters['searchManagerRequest']),
        }, initOverrides);

        if (response._data) { response._data=SearchManagerResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Post a search request to get managers list from it
          */
    async searchManager(requestParameters: SearchManagerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SearchManagerResponse> {
        const response = await this.searchManagerRaw(requestParameters, initOverrides);
        return response._data;
    }

}
